<template>
    <header class="header is-sticky">
        <a aria-current="page" href="/">
            <img src="//dam.malt.com/cms-front/maltLogo.png" alt="Malt Logo" loading="lazy" />
        </a>
    </header>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
    @use '~@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .header {
        background: white;
        border-bottom: solid 1px var(--joy-color-neutral-30);
        padding: 6px 32px;
        display: flex;
        align-items: center;

        img {
            width: 110px;
            height: 32px;
        }

        @include mq.screen_sm {
            justify-content: center;

            img {
                width: 125px;
                height: 37px;
            }
        }
    }
</style>
